/**
 * Setup a replace reducer for a specific action type.
 * Will take the payload passed in and replace the previous state
 * @param type The action type
 * @param initialState The initial state
 */
export default function replaceReducer(type, initialState) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch (action === null || action === void 0 ? void 0 : action.type) {
      case type:
        {
          return action.payload;
        }
      default:
        return state;
    }
  };
}
//# sourceMappingURL=replaceReducer.js.map